// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-player__heading[data-v-924b53b6]{position:relative}.w-player__summary[data-v-924b53b6]{margin-top:24px;text-align:center;line-height:32px}.w-player__summary__text[data-v-924b53b6]{white-space:pre-wrap;word-break:break-word;text-overflow:unset;overflow:hidden}", ""]);
// Exports
module.exports = exports;
